import { APIModelImpl, APIModelHandler } from '../../../../toolkit/uicomponentapimodel';
import { BaseContext } from '../../../../../utils/basecontext';
import { BannerSearchListAPIModel } from './bannersearchlistapimodel';
import { GetBannerDetailsResponse } from '../../../../../core/api/banner/getbannerdetails/getbannerdetailsresponse';
import { GetBannerDtoImpl } from '../../../../../core/dto/getbannerdetails/getbannerdto';
import { GetBannerDetailsRequestImpl } from '../../../../../core/api/banner/getbannerdetails/getbannerdetailsrequest';
import { BannerProcessorFactory } from '../../../../../core/processorfactory/bannerprocessorfactory';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export class GetBannerDetailsListAPIModelImpl extends APIModelImpl implements BannerSearchListAPIModel
{
    private bannerProcessor: BannerProcessorFactory;
   
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);

        this.bannerProcessor = this.getAPIProcesssorFactory().getBannerAPIProcessorFactory();
    }

    getListofBannerTones(order: string, type: string, searchKey: string,startIndex: number, offset: number): void
    {
        let bannerDto = new GetBannerDtoImpl();
        bannerDto.setIdentifier("GetBannerSongs");
        // bannerDto.setBannerType(type);
        // bannerDto.setBannerOrder("4");
        bannerDto.setBannerOrder(order);
        console.log("ORDER ======> "+order);
        console.log("TYPE ======> "+type);
        if(this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH)
        {
            bannerDto.setBannerType(type === "Manual" ? "3" : "4"); 
        }
        else
        {
            bannerDto.setBannerType(type === "Manual" ? "6" : "5"); 
        }
        //Type of Banner.  4 for English Pre booking, 5 for Arabic Pre booking, 3 for English Manual, 6 for Arabic Manual
        
       this.bannerProcessor.getGetBannerDetails()
                   .success((bannerResponse : GetBannerDetailsResponse)=>
                    {
                        console.log("---banner: " + JSON.stringify(bannerResponse.getListOfGetBannerDtos()));
                        this.getAPIModelHandler().onSuccess(bannerResponse.getAPIFeature(), 
                        bannerResponse.getDescription(), bannerResponse.getListOfGetBannerDtos());
                    })
                  .failure((bannerResponse : GetBannerDetailsResponse)=>
                  {
                      this.getAPIModelHandler().onFailure(bannerResponse.getAPIFeature(), 
                      bannerResponse.getDescription(), bannerResponse);
                    })
                  .execute(new GetBannerDetailsRequestImpl(bannerDto));    
    }
}


 



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/banner/bannerlist/getbannerlistapimodel.tsx